import React, {
  useState,
  useContext,
  useRef,
  useEffect,
  useCallback,
} from "react"
import styles from "../../styles/Page-with-Sidebar.module.css"
import { UserContext } from "../../context/userContext"
import { GpraContext } from "../../context/gpraContext"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import axios from "axios"
import { endpoints } from "../../config/gpraApiEndpoints"
import { availableSections, showMessage } from "./utils/utils"
import { Toast } from "primereact/toast"
import NavigationBar from "./NavigationBar/NavigationBar"
import "./NavigationBar/navigationBar.css"
import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"
import { gpraUrl } from "../../config/microservicesUrls"
import { LoaderMedium } from "../../components/Loaders"
import gpraStyles from "../../../src/styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "./types/interviewTypes"
import GpraNotElegible from "./GpraNotElegible/GpraNotElegible"
import ParticipantProfileBoxSmall from "../../components/ParticipantProfileBoxSmall"
import { DateTime } from "luxon"
import { useQuery } from "@apollo/client"
import { GET_GPRA_STATUS } from "./queries"
import GpraMain from "./GpraMain"
import Locked from "./Locked"

export default function GPRAForms() {
  const userCtx = useContext(UserContext)

  const { pathname } = useLocation()
  useEffect(() => {
    if (pathname === "/participant/gpra-forms") {
      setInterviewType()
      setActiveIndex(0)
      setSectionsCompleted({})
    }
  }, [pathname])
  const [cancellingInterview, setCancellingInterview] = useState()
  const [pdfDownloading, setPdfDownloading] = useState()
  const [plannedServices4Saved, setPlannedServices4Saved] = useState()
  const [interviewType, setInterviewType] = useState()
  const [interviewStatus, setInterviewStatus] = useState()
  const [activeIndex, setActiveIndex] = useState(0)
  const [summary, setSummary] = useState(false)
  const [loadingStatus, setLoadingStatus] = useState()
  const [loadNext, setLoadNext] = useState(false)
  const [loadPrev, setLoadPrev] = useState(false)
  const [loadFinish, setLoadFinish] = useState(false)
  const [reloadStatus, setReloadStatus] = useState()
  const [sectionsCompleted, setSectionsCompleted] = useState({})
  const [loadingQuestions, setLoadingQuestions] = useState(false)
  const [loadingMicroserviceStatus, setLoadingMicroserviceStatus] =
    useState(true)
  const [microserviceStatus, setMicroserviceStatus] = useState(null)
  const [questions, setQuestions] = useState()
  const [additionalQuestions, setAdditionalQuestions] = useState()
  const [loadingAdditionalQuestions, setLoadingAdditionalQuestions] = useState()
  const [blocked, setBlocked] = useState()
  const toast = useRef()
  const navigate = useNavigate()
  const [interview, setInterview] = useState({})
  const [administrativeInterview, setAdministrativeInterview] =
    useState(undefined)
  const [showGpraHistory, setShowGpraHistory] = useState(false)
  const [sections, setSections] = useState([])
  const [pollServer, setPollServer] = useState(false)
  const [editMode, setEditMode] = useState(false)

  const inactiveParticipantStatus = {
    INACTIVE_DISCHARGED: "Inactive Discharged",
    INACTIVE_REFERRALS: "Inactive Referrals",
    KIOSK_MEMBER: "Kiosk Member",
  }
  const getParticipantStatus = useCallback(() => {
    if (userCtx.current_participant_id && userCtx.participant_membership_id) {
      setLoadingStatus(true)
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokenGpra}`,
        },
        params: {
          gpra_participant_uuid: userCtx.current_participant_id,
          gpra_membership_uuid: userCtx.participant_membership_id,
          interview_type: interviewType,
        },
      }
      axios
        .get(`${gpraUrl()}${endpoints.INTERVIEW_STATUS}`, config)
        .then((response) => {
          if (response.status === 200) {
            setInterviewStatus(response.data)
            const int = response.data.gpraInterview
            let date_start
            if (int?.dateStart) {
              date_start = DateTime.fromISO(int?.dateStart, {
                zone: "utc",
              }).toLocal()
            } else {
              date_start = new Date()
            }
            interview[INTERVIEW_SECTIONS.RECORD_MGMT] = {
              gpra_client_type: int?.gpraRecord?.gpraClientType,
              gpra_interview_date: int?.completedInterview
                ? new Date(date_start)
                : new Date(),
              gpra_avail_date: int?.gpraAvail,
              gpra_participant_id: int?.gpraRecord?.gpraParticipantId,
              gpra_participant_uuid: int?.gpraRecord?.gpraParticipantUuid,
              gpra_membership_uuid: int?.gpraRecord?.gpraMembershipUuid,
              organization_uuid: int?.gpraRecord?.organizationUuid,
              staff_id: int?.gpraStaffUuid,
              staff_alias: userCtx.session.user.staff_alias,
              interview_id: int?.gpraInterviewID,
              record_id: int?.gpraRecordId,
              additional: response.data.additional,
              gpra_interview_conducted: undefined,
            }
            if (new Date(int?.dateStart).getFullYear() > 1) {
              if (int?.administrativeInterview !== undefined) {
                interview[
                  INTERVIEW_SECTIONS.RECORD_MGMT
                ].gpra_interview_conducted = !int?.administrativeInterview
                setAdministrativeInterview(!int?.administrativeInterview)
              }
            }
            setInterview(interview)
            setLoadingStatus(false)
          } else {
            setLoadingStatus(false)
            setInterview({})
            setInterviewStatus()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    userCtx.current_participant_id,
    userCtx.participant_membership_id,
    userCtx.tokenGpra,
    interviewType,
    userCtx.session.user.staff_alias,
    userCtx.session.user.staff_id,
  ])

  useEffect(() => {
    if (reloadStatus) {
      getParticipantStatus()
    }
  }, [reloadStatus, getParticipantStatus])

  useEffect(() => {
    getParticipantStatus()
  }, [getParticipantStatus])

  const getCustomizations = useCallback(() => {
    if (userCtx.session.user.organization_id && interviewType) {
      setLoadingQuestions(true)
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokenGpra}`,
        },
      }
      axios
        .post(
          `${gpraUrl()}${endpoints.GET_CUSTOMIZATIONS}`,
          {
            organization_id: userCtx.session.user.organization_id,
            interview_type: interviewType,
            organizations: [],
          },
          config
        )
        .then((response) => {
          if (response.status === 200) {
            setQuestions(response.data.customizations)
          }
          setLoadingQuestions(false)
        })
        .catch(() => {
          setLoadingQuestions(false)
        })
    }
  }, [userCtx.session.user.organization_id, userCtx.tokenGpra, interviewType])

  const getAdditionalQuestions = useCallback(() => {
    if (userCtx.session.user.organization_id) {
      setLoadingAdditionalQuestions(true)
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokenGpra}`,
        },
        params: {
          organization_uuid: userCtx.session.user.organization_id,
          form: interviewType,
          staff_id: userCtx.session.user.staff_id,
        },
      }
      axios
        .get(`${gpraUrl()}${endpoints.GET_SECTIONS_ORDERS}`, config)
        .then((response) => {
          if (response.status === 200) {
            setAdditionalQuestions(
              response.data?.sectionsOrders.filter(
                (d) =>
                  d?.additionalQuestion?.form === interviewType ||
                  d?.matrixGroup?.form === interviewType ||
                  d?.questionGroup?.form === interviewType
              )
            )
            if (response?.data?.checkStatus?.blocked) {
              setPollServer(true)
            }
            setBlocked(response?.data?.checkStatus?.blocked)
          }
          setLoadingAdditionalQuestions(false)
        })
        .catch(() => {
          setLoadingAdditionalQuestions(false)
        })
    }
  }, [userCtx.session.user.organization_id, userCtx.tokenGpra, interviewType, userCtx.session.user.staff_id])

  const checkStatus = useCallback(
    (safeCheck) => {
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokenGpra}`,
        },
      }
      axios
        .post(
          `${gpraUrl()}${endpoints.CHECK_ADDITIONAL_STATUS}`,
          {
            organization_uuid: userCtx.session.user.organization_id,
            staff_id: userCtx.session.user.staff_id,
            organizations: [],
          },
          config
        )
        .then((response) => {
          if (!response?.data?.blocked) {
            setBlocked(response?.data?.blocked)
            setPollServer(false)
          }
          if (response?.data?.blocked && safeCheck) {
            userCtx.setNotificationError(
              "Additional questions save process failed. Please contact support service."
            )
          }
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
    userCtx.session.user.organization_id, 
    userCtx.session.user.staff_id, 
    userCtx.setNotificationError, 
    userCtx.tokenGpra
    ]
  )
  useEffect(() => {
    let intervalId
    if (pollServer) {
      intervalId = setInterval(() => {
        checkStatus(false)
      }, 5000)
    } else {
      clearInterval(intervalId)
    }
    return () => {
      clearInterval(intervalId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pollServer, checkStatus])
  useEffect(() => {
    getCustomizations()
    getAdditionalQuestions()
  }, [getCustomizations, getAdditionalQuestions])
  useEffect(() => {
    if (interviewType && interviewStatus) {
      setSections(
        availableSections(
          interviewType,
          questions,
          additionalQuestions,
          administrativeInterview
        )
      )
    }
  }, [
    interviewStatus,
    questions,
    additionalQuestions,
    interviewType,
    administrativeInterview,
  ])
  useQuery(GET_GPRA_STATUS, {
    variables: { staff_id: userCtx.session.user.staff_id, organization_id: userCtx.session.user.organization_id },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setMicroserviceStatus(data)
      setLoadingMicroserviceStatus(false)
    },
    onError: (err) => {
      setMicroserviceStatus(null)
      setLoadingMicroserviceStatus(false)
    },
  })

  const handleSubmitPost = async (endpoint, postBody) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokenGpra}`,
        },
      }
      return await axios.post(`${gpraUrl()}${endpoint}`, postBody, config)
    } catch (error) {
      const message = JSON.parse(error.response.request.responseText).value
      showMessage(false, message, toast)
    }
  }
  const handleSubmitGet = async (endpoint, params) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokenGpra}`,
        },
        params: params,
      }
      return await axios.get(`${gpraUrl()}${endpoint}`, config)
    } catch (error) {
      const message = JSON.parse(error.response.request.responseText).value
      showMessage(false, message, toast)
    }
  }
  const handleSubmitPut = async (endpoint, putBody) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokenGpra}`,
        },
      }
      return await axios.put(`${gpraUrl()}${endpoint}`, putBody, config)
    } catch (error) {
      const message = JSON.parse(error.response.request.responseText).value
      showMessage(false, message, toast)
    }
  }
  const updateInterviewValues = (section, value) => {
    interview[section] = value
    setInterview(interview)
  }
  const handleInterviewType = (value) => {
    setInterviewType(value)
  }
  const handleActiveIndex = (value) => {
    setActiveIndex(value)
  }
  const loadCollection = (data, collection) => {
    if (
      !interview[collection] ||
      Object.entries(interview[collection]).length === 0 ||
      collection === INTERVIEW_SECTIONS.SUBSTANCE_USE_1
    ) {
      updateInterviewValues(collection, data)
    }
  }
  const handleCancellingInterview = (value) => {
    setCancellingInterview(value)
  }
  const handlePdfDownloading = (value) => {
    setPdfDownloading(value)
  }
  const handleSummary = (value) => {
    setSummary(value)
  }
  const handleLoadNext = (value) => {
    setLoadNext(value)
  }
  const handleLoadPrev = (value) => {
    setLoadPrev(value)
  }
  const handleLoadFinish = (value) => {
    setLoadFinish(value)
  }
  const handlePlannedServices4Saved = (value) => {
    setPlannedServices4Saved(value)
  }
  const handleReloadStatus = (value) => {
    setReloadStatus(value)
  }
  const handleSectionsCompleted = (value) => {
    setSectionsCompleted(value)
  }
  const clearContext = () => {
    updateInterviewValues(INTERVIEW_SECTIONS.DEMOGRAPHICS, {})
    updateInterviewValues(INTERVIEW_SECTIONS.PLANNED_SERVICES_1, {})
    updateInterviewValues(INTERVIEW_SECTIONS.PLANNED_SERVICES_2, {})
    updateInterviewValues(INTERVIEW_SECTIONS.PLANNED_SERVICES_3, {})
    updateInterviewValues(INTERVIEW_SECTIONS.PLANNED_SERVICES_4, {})
    updateInterviewValues(INTERVIEW_SECTIONS.SUBSTANCE_USE_1, {})
    updateInterviewValues(INTERVIEW_SECTIONS.SUBSTANCE_USE_2, {})
    updateInterviewValues(INTERVIEW_SECTIONS.SUBSTANCE_USE_3, {})
    updateInterviewValues(INTERVIEW_SECTIONS.FAMILY, {})
    updateInterviewValues(INTERVIEW_SECTIONS.EDUCATION, {})
    updateInterviewValues(INTERVIEW_SECTIONS.LEGAL, {})
    updateInterviewValues(INTERVIEW_SECTIONS.MENTAL, {})
    updateInterviewValues(INTERVIEW_SECTIONS.SOCIAL, {})
    updateInterviewValues(INTERVIEW_SECTIONS.PROGRAM, {})
    updateInterviewValues(INTERVIEW_SECTIONS.FOLLOW_UP, {})
    updateInterviewValues(INTERVIEW_SECTIONS.DISCHARGE, {})
    updateInterviewValues(INTERVIEW_SECTIONS.SERVICES_RECEIVED_1, {})
    updateInterviewValues(INTERVIEW_SECTIONS.SERVICES_RECEIVED_2, {})
    updateInterviewValues(INTERVIEW_SECTIONS.SERVICES_RECEIVED_3, {})
    updateInterviewValues(INTERVIEW_SECTIONS.SERVICES_RECEIVED_4, {})
    updateInterviewValues(INTERVIEW_SECTIONS.SERVICES_RECEIVED_5, {})
    updateInterviewValues(INTERVIEW_SECTIONS.RECORD_MGMT, {})
    setAdministrativeInterview(undefined)
    setEditMode(false)
  }
  const contextValue = {
    handleSubmitPost,
    handleSubmitPut,
    handleSubmitGet,
    plannedServices4Saved,
    handlePlannedServices4Saved,
    loadCollection,
    interviewType,
    handleInterviewType,
    activeIndex,
    handleActiveIndex,
    cancellingInterview,
    handleCancellingInterview,
    pdfDownloading,
    handlePdfDownloading,
    summary,
    handleSummary,
    handleLoadNext,
    loadNext,
    handleLoadPrev,
    loadPrev,
    handleLoadFinish,
    loadFinish,
    handleReloadStatus,
    sectionsCompleted,
    handleSectionsCompleted,
    questions,
    additionalQuestions,
    interview,
    updateInterviewValues,
    setAdministrativeInterview,
    administrativeInterview,
    setQuestions,
    sections,
    clearContext,
    editMode,
  }
  const updateUrl = (url) => {
    return navigate(url)
  }
  const checkDate = (date) => {
    const minDate = new Date(date).getFullYear() === 1
    return minDate ? "No date" : date
  }
  const inactiveParticipant = () => {
    return (
      userCtx.participant_membership_status ===
        inactiveParticipantStatus.INACTIVE_DISCHARGED ||
      userCtx.participant_membership_status ===
        inactiveParticipantStatus.INACTIVE_REFERRALS ||
      userCtx.participant_membership_status === inactiveParticipantStatus.KIOSK_MEMBER
    )
  }
  if (
    loadingStatus ||
    loadingQuestions ||
    loadingAdditionalQuestions ||
    loadingMicroserviceStatus
  ) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <div className="layout-with-sidebar">
      <div className="sidebar">
        <ParticipantSidebar />
      </div>
      {interviewStatus ? (
        <div className="main-content">
          <ParticipantProfileBoxSmall />
          <GpraContext.Provider value={contextValue}>
            <div className={styles.content}>
              <Toast ref={toast} />
              {interviewType && interview["recordManagement"] ? (
                <div className={gpraStyles.wrapper}>
                  {!summary && (
                    <div className={gpraStyles.navigation}>
                      <NavigationBar />
                    </div>
                  )}
                  <div className={gpraStyles.content}>
                    <Outlet />
                  </div>
                </div>
              ) : !microserviceStatus.isMicroservicesActive ||
                microserviceStatus?.isMicroservicesActive
                  ?.microservices_enabled === "0" ? (
                <Locked />
              ) : (
                <GpraMain
                  blocked={blocked}
                  checkDate={checkDate}
                  clearContext={clearContext}
                  inactiveParticipant={inactiveParticipant}
                  interviewStatus={interviewStatus}
                  loadingStatus={loadingStatus}
                  setEditMode={setEditMode}
                  setReloadStatus={setReloadStatus}
                  setShowGpraHistory={setShowGpraHistory}
                  showGpraHistory={showGpraHistory}
                  updateUrl={updateUrl}
                />
              )}
            </div>
          </GpraContext.Provider>
        </div>
      ) : (
        <div className="main-content">
          <ParticipantProfileBoxSmall />
          {!microserviceStatus.isMicroservicesActive ||
          microserviceStatus?.isMicroservicesActive?.microservices_enabled ===
            "0" ? (
            <Locked />
          ) : (
            <GpraNotElegible
              staff_id={userCtx.session.user.staff_id}
              organization_id={userCtx.session.user.organization_id}
              membership_uuid={userCtx.participant_membership_id}
              participant_uuid={userCtx.current_participant_id}
              participant_id={userCtx.participant_alias}
              organization_alias={userCtx.session.user.organization_alias}
              participant_name={`${userCtx.participant_name_first} ${userCtx.participant_name_last}`}
              organization_name={userCtx.session.user.organization_name}
              setReloadStatus={setReloadStatus}
              programs_list={userCtx.program_list}
              inactiveParticipant={inactiveParticipant()}
              message={true}
            />
          )}
        </div>
      )}
    </div>
  )
}
